import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedControlsComponent } from './shared-controls.component';
import { NewAudioPlayerComponent } from "./new-audio-player/new-audio-player.component";


@NgModule({
  imports: [
    CommonModule,FormsModule
  ],
  declarations: [SharedControlsComponent,NewAudioPlayerComponent],
  exports:[NewAudioPlayerComponent]
})
export class SharedControlsModule { }



// WEBPACK FOOTER //
// ./src/app/application/core-module/shared-controls/shared-controls.module.ts